import { render, staticRenderFns } from "./SBlockTypeSelection.vue?vue&type=template&id=4e8b8f50&scoped=true&"
import script from "./SBlockTypeSelection.vue?vue&type=script&lang=js&"
export * from "./SBlockTypeSelection.vue?vue&type=script&lang=js&"
import style0 from "./SBlockTypeSelection.vue?vue&type=style&index=0&id=4e8b8f50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b8f50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VSpacer,VToolbar,VToolbarTitle})
